const appleAuthenticationData = document.getElementById(
  'apple-authentication-data'
).dataset

// eslint-disable-next-line no-undef
AppleID.auth.init({
  clientId: appleAuthenticationData.clientId,
  scope: 'name email',
  redirectURI: appleAuthenticationData.redirectUri,
  state: appleAuthenticationData.buttonState,
  usePopup: true
})

document.addEventListener('AppleIDSignInOnSuccess', async event => {
  const { id_token: idToken, state } = event.detail.authorization
  const { user } = event.detail

  const form = document.getElementById('apple-form')
  const idTokenInput = document.getElementById('apple-id')
  const stateInput = document.getElementById('apple-state')
  const firstNameInput = document.getElementById('apple-user-first-name')
  const middleNameInput = document.getElementById('apple-user-middle-name')
  const lastNameInput = document.getElementById('apple-user-last-name')

  idTokenInput.value = idToken
  stateInput.value = state

  if (user && user.name) {
    firstNameInput.value = user.name.firstName || ''
    middleNameInput.value = user.name.middleName || ''
    lastNameInput.value = user.name.lastName || ''
  }

  form.submit()
})

document.addEventListener('AppleIDSignInOnFailure', error => {
  if (error && error.detail && error.detail.error) {
    if (error.detail.error === 'popup_closed_by_user') {
      return
    }
    throw new Error(
      `Apple authentication failed with code "${error.detail.error}"`
    )
  }

  throw new Error('Apple authentication failed, unknown error code')
})
